import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes, { oneOf } from 'prop-types';

import WithLang, { langType } from '../../../i18n/WithLang';
import SelectSchemaDialog from '../../SelectSchemaDialog';
import { surveyTypeValues } from '../../../constants/types';
import SurveyBox from '../../SurveyBox';

const SurveyTypeBox = ({
  title, text, showStartSurveyButton, viewUrl, translate, type
}) => (
  <SurveyBox
    title={title}
    text={text}
    content={(
      <div>
        {showStartSurveyButton && (
        <SelectSchemaDialog schemaType={type}>
          <button type="button" data-cy="start-survey-button" className="button--outline">{translate('surveysLandingPage.buttons.start')}</button>
        </SelectSchemaDialog>
        )}
        <Link to={viewUrl} data-cy="browse-surveys-button" className="button">{translate('surveysLandingPage.buttons.browse')}</Link>
      </div>
      )}
  />
);

SurveyTypeBox.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: oneOf(Object.values(surveyTypeValues)).isRequired,
  showStartSurveyButton: PropTypes.bool.isRequired,
  viewUrl: PropTypes.string.isRequired,
  ...langType
};

export default WithLang(SurveyTypeBox);
